/* eslint-disable camelcase */
type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_thousands_of_yoga_practices_to_inspire_and_uplift: Phrase = locale => {
  const en = `Thousands of Yoga Practices to Inspire and Uplift`;
  const phrases: { [key: string]: undefined | string } = {
    en,
    es: `Miles de prácticas de yoga para inspirarte.`,
  };
  return phrases[locale] || en;
};
